import { useSelectState } from './store/selectors.js';
import { useSetState } from './store/state-setters.js';
import { useHistogramInteractions } from './useHistogramInteractions.js';
import { useHistogramXScale } from './useHistogramXScale.js';
import { useInfiniteZoomConfig } from './useInfiniteZoomConfig.js';
import { reduceZoomDomain } from '../../core/components/interactions-state-helpers/reducers/zoom-reducers.js';
import { getZoomStep } from '../../core/components/zoom/utils/get-zoom-step.js';

export const useZoomToSelection = () => {
  const { onZoomChange } = useHistogramInteractions();

  const { xScale, initialXScale } = useHistogramXScale();
  const infiniteZoom = useInfiniteZoomConfig();
  const setState = useSetState();

  const select = useSelectState();

  return () => {
    if (!select) {
      return;
    }

    const initialDomain = initialXScale.domain();

    const { nextDomain, zoomInEnabled, zoomOutEnabled } = getZoomStep(
      xScale,
      [+initialDomain[0], +initialDomain[1]],
      infiniteZoom,
      select.start.relative.x,
      select.end.relative.x,
      'zoom-x',
    );

    onZoomChange?.(nextDomain[0], nextDomain[1], 'zoom-x');
    setState(
      reduceZoomDomain(
        [+nextDomain[0], +nextDomain[1]],
        zoomInEnabled,
        zoomOutEnabled,
      ),
    );
  };
};
